import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { OptionDateChange } from '@app/utils/option-date-changes.util';

@Component({
  selector: 'option-date-changes',
  templateUrl: './option-date-changes.component.html',
  styleUrls: ['./option-date-changes.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OptionDateChangesComponent {
  @Input() changes: OptionDateChange[] = [];
}
